














import Vue from "vue";
import { required, integer } from "vuelidate/lib/validators";
import dialog from "@/common/mixins/dialog";
import ShipnityEditorForm from "../components/ShipnityEditorForm.vue";
import { ShipnityUpdateForm } from "../forms/ShipnityUpdateForm";
import { Shop } from "../../shop/models/Shop";
export default Vue.extend({
  mixins: [dialog],
  components: {
    ShipnityEditorForm
  },
  validations: {
    shipnityUpdateForm: {
      shop: { required },
      shopName: { required },
      email: { required },
      token: { required },
      mcApiKey: { required },
      mcSecretkey: { required },
      stockIdValue: { integer }
    }
  },
  data() {
    const shops: Shop[] = [];
    const shipnityUpdateForm: ShipnityUpdateForm = {
      shopName: "",
      email: "",
      token: "",
      mcApiKey: "",
      mcSecretkey: ""
    };
    return { shipnityUpdateForm, shops };
  },
  async created() {
    await Promise.all([this.getShops()]);
    await this.getShipnityById(+this.$route.params.id);
  },
  methods: {
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    goToShipnityViewPage() {
      this.$router.push({ name: "ShipnityViewPage" });
    },
    async getShipnityById(id: number) {
      try {
        const {
          data
        } = await (this as any).$dep.shipnityUseCase.getShipnityById(id);
        const shop = this.shops.find(shop => {
          return shop.id === data.shopId;
        });

        this.shipnityUpdateForm = { ...data, shop };
      } catch (error) {
        console.log(error);
      }
    },
    async updateShipnity(id: number) {
      try {
        await (this as any).$dep.shipnityUseCase.updateShopShipnity(
          id,
          this.shipnityUpdateForm
        );
        if (
          await (this as any).alertSuccess("Success", "Update Shipnity สำเร็จ")
        ) {
          this.goToShipnityViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError(
                "Error",
                "ไม่สามารถ Update Shopify นี้ได้"
              )
            : (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to update Shipnity",
        "คุณต้องการ Update Shipnity หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.updateShipnity(+this.$route.params.id);
      }
    },
    clear() {
      this.$v.$reset();
      this.shipnityUpdateForm = {
        shopName: "",
        email: "",
        token: "",
        mcApiKey: "",
        mcSecretkey: ""
      };
    }
  }
});
